import { SuccessfulSubmitController } from './successfulSubmit.controller';
import { template } from './successfulSubmit.roles';

export const successfulSubmitComponent = {
  name: 'successfulSubmitComponent',
  restrict: 'E',
  template,
  controller: SuccessfulSubmitController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<'
  }
};
